import { useState } from 'react'
import type { AdminSectionProps } from './types'
import { ActiveCatalogSection } from './ActiveCatalogSection'
import { CatalogImportSection } from './CatalogImportSection'
import { CatalogVersionsSection } from './CatalogVersionsSection'
import { CategoriesSection } from './CategoriesSection'
import { PosModerationSection } from './PosModerationSection'
import { CatalogDiagnosticsSection } from './CatalogDiagnosticsSection'
import { AdminCard } from './AdminCard'

/**
 * Раздел «Каталог» — тонкий контейнер: только композиция блоков.
 *
 * Порядок окон задан приоритетом работы директора: активный каталог →
 * заявки с касс → импорт → категории → история → диагностика. По умолчанию
 * развёрнуты только «Каталог активной версии» и «Категории».
 *
 * refreshKey синхронизирует историю версий и активный каталог после локального
 * импорта или отката версии.
 */
export function CatalogSection({ core, perms, cashier }: AdminSectionProps) {
  const [refreshKey, setRefreshKey] = useState(0)
  const bump = () => setRefreshKey((k) => k + 1)

  return (
    <>
      <AdminCard
        id="catalog.active"
        title="Каталог активной версии"
        defaultOpen
        fullHeight
      >
        <ActiveCatalogSection core={core} refreshKey={refreshKey} />
      </AdminCard>

      <AdminCard id="catalog.moderation" title="Заявки с касс">
        <PosModerationSection core={core} perms={perms} cashier={cashier} />
      </AdminCard>

      <AdminCard id="catalog.import" title="Импорт каталога">
        <CatalogImportSection core={core} onImported={bump} />
      </AdminCard>

      <AdminCard id="catalog.categories" title="Категории" defaultOpen>
        <CategoriesSection core={core} refreshKey={refreshKey} />
      </AdminCard>

      <AdminCard id="catalog.versions" title="История версий каталога">
        <CatalogVersionsSection
          core={core}
          refreshKey={refreshKey}
          onRolledBack={bump}
        />
      </AdminCard>

      {/* Локальная диагностика нужна только администратору. */}
      {cashier?.role === 'admin' && (
        <AdminCard id="catalog.diagnostics" title="Диагностика каталога устройства">
          <CatalogDiagnosticsSection core={core} refreshKey={refreshKey} />
        </AdminCard>
      )}
    </>
  )
}
